import p17_img from "./shoes_kids/p17.jpg";
import p18_img from "./shoes_kids/p18.jpg";
import p19_img from "./shoes_kids/p19.jpg";
import p20_img from "./shoes_kids/p20.jpg";

let data_product2 = [
  {
    id: 17,
    name: "COURT HIGH - GLITTER MIX",
    category: "kid",
    image: p17_img,
    new_price: 859.0,
    old_price: 1209.0,
    descriptions: "Get that ideal clean style with enhanced comfort wearing the SKECHERS Court High-Glitter Mix Smooth Clean Synthetic upper in a lace up sneaker with stitching, perforation",
  },
  {
    id: 18,
    name: "GLIMMER KICKS - FRESH GLOW",
    category: "kid",
    image: p18_img,
    new_price: 859.0,
    old_price: 1299.0,
    descriptions: "Shine through the day in sporty comfort with Skechers S Lights® Glimmer Kicks - Fresh Glow. This lighted design features an athletic mesh and synthetic upper with stretc",
  },
  {
    id: 19,
    name: "GO RUN 400-INTREPID",
    category: "kid",
    image: p19_img,
    new_price: 1299.0,
    old_price: 1599.0,
    descriptions: "Perfect to keep your feet comfortable throughout your playing sessions, this pair sport shoes from Skechers ensures to provide you with the required performance. Its mesh upper will",
  },
  {
    id: 20,
    name: "RAZOR FLEX AIR",
    category: "kid",
    image: p20_img,
    new_price: 1009.0,
    old_price: 1359.0,
    descriptions: "A sporty style that keeps up with his every move comes in the Skechers Razor Flex AIR - shoe. This lightweight Gore & Strap Sneaker with Lateral Tech Piece and mesh upper with an Ai",
  },
];

export default data_product2;